import React, { useState } from 'react'

const AddNewFounder = ({ isOpen, onClose, ref, setShowAddNewFounderPopup, setShowNotification, setNotificationMessage, setErrorMessage, errorMessage }) => {
    const [email, setEmail] = useState('')
    if (!isOpen) return null;

    const handleSend = () => {
        if (!email?.trim()) {
            setErrorMessage('Please fill email address.')
        } else {
            setShowAddNewFounderPopup(false);
            setShowNotification(true);
            setTimeout(() => {
                setShowNotification(false)
            }, 8000)
            setNotificationMessage(`Invitation sent to ${email}`)
        }
    }
    return (
        <>
            <div className="popup-overlay">
                <div className="popup-box" ref={ref}>
                    <div className='popup-top-content'>
                        <div className="popup-close" onClick={onClose}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className='popup-content'>
                            <div className='popup-title'>Add a new founder</div>
                            <p className="description">
                                To add a new founder, simply enter their email address below.
                            </p>
                            <p className="warning">
                                We’ll send them an email with a temporarily password so they can complete their registration and join Ivycorn.
                            </p>
                        </div>
                        <div className={`input-group ${email ? 'filled' : ''} ${errorMessage ? 'show-error update-input-group' : ''}`}>
                            <input type="email" id='email' className='' name='email' autoComplete="off" value={email} onChange={(e) => {
                                setEmail(e.target.value)
                                if (errorMessage) {
                                    setErrorMessage('');
                                }
                            }} />
                            <label htmlFor="email">Personal email address</label>
                        </div>
                        {errorMessage && (<p className="error-message">{errorMessage}</p>)}
                    </div>
                    <div className="button-row">
                        <button className="cancel-btn" onClick={onClose}>Cancel</button>
                        <button className="suspend-btn add-founder-btn" onClick={() => {
                            handleSend()
                        }}>Send</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddNewFounder